import { SpecificationCategory } from '../enum/SpecificationCategory';

interface ISpecificationsMap {
  engine: { [key: string]: { category: SpecificationCategory; translationKey?: string } };
  model: { [key: string]: { category: SpecificationCategory; translationKey?: string } };
}

const modelSpecificationsMap: ISpecificationsMap = {
  engine: {
    brand: { category: SpecificationCategory.engine, translationKey: 'motor_brand' },
    oemcode: { category: SpecificationCategory.engine, translationKey: 'motor_type' },
    capacity: { category: SpecificationCategory.engine, translationKey: 'motor_displacement' },
    shortdescription: { category: SpecificationCategory.engine, translationKey: 'motor_cylinders_number' },
    maximumpower: { category: SpecificationCategory.engine, translationKey: 'motor_power' },
    maximumtorque: { category: SpecificationCategory.engine, translationKey: 'motor_torque' },
    powersystem: { category: SpecificationCategory.engine, translationKey: 'motor_power_system' },
    powertrain: { category: SpecificationCategory.engine, translationKey: 'motor_injection_system' },
    environmentalstandard: { category: SpecificationCategory.engine, translationKey: 'motor_environmental_standard' },
    possiblefuels: { category: SpecificationCategory.engine, translationKey: 'motor_fuel' },
    environmentalstandarddisclaimer: { category: SpecificationCategory.engine },
    transmissionreference: { category: SpecificationCategory.transmission, translationKey: 'transmission_reference' },
    gearnumbers: { category: SpecificationCategory.transmission, translationKey: 'transmission_numbers_of_gears' },
    transmission: { category: SpecificationCategory.transmission, translationKey: 'transmission_type' },
    relationship1: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_1a' },
    relationship2: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_2a' },
    relationship3: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_3a' },
    relationship4: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_4a' },
    relationship5: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_5a' },
    relationship6: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_6a' },
    relationship7: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_7a' },
    relationship8: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_8a' },
    relationship9: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_9a' },
    relationship10: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_10a' },
    relationship11: { category: SpecificationCategory.transmission, translationKey: 'transmission_relations_11a' },
    reverse1: { category: SpecificationCategory.transmission, translationKey: 'transmission_reverse_1a' },
    reverse2: { category: SpecificationCategory.transmission, translationKey: 'transmission_reverse_2a' },
    reverse3: { category: SpecificationCategory.transmission, translationKey: 'transmission_reverse_3a' },
    reverse: { category: SpecificationCategory.transmission, translationKey: 'transmission_reverse' },
    finalshaftratio: {
      category: SpecificationCategory.transmission,
      translationKey: 'transmission_axle_final_relation',
    },
    traction: { category: SpecificationCategory.transmission, translationKey: 'transmission_traction' },
    grossvehicleweight: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_gross_weight',
    },
    grosscombinedvehicleweight_c2s1: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_gross_weight_c2s1',
    },
    grosscombinedvehicleweight_c2s2: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_gross_weight_c2s2',
    },
    grosscombinedvehicleweight_c2s3: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_gross_weight_c2s3',
    },
    chassisweight: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_chassis_weight',
    },
    grossloadcapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_gross_load_capacity',
    },
    frontaxlecapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_front_axle_capacity',
    },
    rearaxlecapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_rear_axle_capacity',
    },
    frontsuspensioncapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_front_suspension',
    },
    rearsuspensioncapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_rear_suspension',
    },
    offroadaxlecapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_off_road_axle',
    },
    fueltank: { category: SpecificationCategory.weightsAndCapacities, translationKey: 'weights_capacities_fuel_tank' },
    bluetank: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_ad_blue_tank',
    },
    slopestartingcapability: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_hill_start_capacity',
    },
    cartercapacity: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_carter_capacity',
    },
    tireturningradius: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_tire_turning_radius',
    },
    crewnumber: {
      category: SpecificationCategory.weightsAndCapacities,
      translationKey: 'weights_capacities_crew_number',
    },
    cartercapacitydisclaimer: { category: SpecificationCategory.weightsAndCapacities },
    grossweightdisclaimer: { category: SpecificationCategory.weightsAndCapacities },
    address: { category: SpecificationCategory.chassis, translationKey: 'chassis_steering' },
    frontaxlesuspensiontype: {
      category: SpecificationCategory.chassis,
      translationKey: 'chassis_front_axle_suspension_type',
    },
    frontaxleshockabsorber: {
      category: SpecificationCategory.chassis,
      translationKey: 'chassis_front_axle_shock_absorbers',
    },
    rearaxlesuspensiontype: {
      category: SpecificationCategory.chassis,
      translationKey: 'chassis_rear_axle_suspension_type',
    },
    rearaxleshockabsorber: {
      category: SpecificationCategory.chassis,
      translationKey: 'chassis_rear_axle_shock_absorbers',
    },
    brakingsystemtype: { category: SpecificationCategory.brakingSystem, translationKey: 'braking_system_type' },
    nominalvoltage: { category: SpecificationCategory.electricSystem, translationKey: 'electric_system_rated_voltage' },
    alternatorcapacity: {
      category: SpecificationCategory.electricSystem,
      translationKey: 'electric_system_alternator_capacity',
    },
    batterynumber: {
      category: SpecificationCategory.electricSystem,
      translationKey: 'electric_system_number_batteries',
    },
    batterycapacity: {
      category: SpecificationCategory.electricSystem,
      translationKey: 'electric_system_battery_capacity',
    },
  },
  model: {
    radio: { category: SpecificationCategory.equipment, translationKey: 'equipment_radio' },
    doorbrake: { category: SpecificationCategory.equipment, translationKey: 'equipment_door_break' },
    toolkit: { category: SpecificationCategory.equipment, translationKey: 'equipment_tool_kit' },
    electromagnetic_retarder: {
      category: SpecificationCategory.equipment,
      translationKey: 'equipment_electromagnetic_retarder',
    },
    sparerim: { category: SpecificationCategory.equipment, translationKey: 'equipment_replacement_rim' },
    sparetire: { category: SpecificationCategory.equipment, translationKey: 'equipment_spare_tire' },
    foldingchairs: { category: SpecificationCategory.equipment, translationKey: 'equipment_folding_chairs' },
    hillstartsystem: { category: SpecificationCategory.equipment, translationKey: 'equipment_hill_start_system_ES' },
    idlestop: { category: SpecificationCategory.equipment, translationKey: 'equipment_idle_stop' },
    cabin: { category: SpecificationCategory.equipment, translationKey: 'equipment_cabin' },
    differentiallock: { category: SpecificationCategory.equipment, translationKey: 'equipment_differential_lock' },
    airconditioning: { category: SpecificationCategory.equipment, translationKey: 'equipment_air_conditioning' },
    hourmeter: { category: SpecificationCategory.equipment, translationKey: 'equipment_hourmeter' },
    explorers: { category: SpecificationCategory.equipment, translationKey: 'equipment_fog_lights' },
    slopeassist: { category: SpecificationCategory.equipment, translationKey: 'equipment_slope_assistant' },
    reversealarm: { category: SpecificationCategory.equipment, translationKey: 'equipment_reverse_alarm' },
    fifthwheel: { category: SpecificationCategory.equipment, translationKey: 'equipment_fifth_wheel' },
    address: { category: SpecificationCategory.equipment, translationKey: 'equipment_steering' },
    display: { category: SpecificationCategory.equipment, translationKey: 'equipment_display' },
    coolanttemperature: { category: SpecificationCategory.equipment, translationKey: 'equipment_coolant_temperature' },
    idlestopdisclaimer: { category: SpecificationCategory.equipment },
    dimensions_length: { category: SpecificationCategory.dimensions, translationKey: 'dimensions_total_length' },
    dimensions_width_mirrorsout: {
      category: SpecificationCategory.dimensions,
      translationKey: 'dimensions_total_width',
    },
    dimensions_height: { category: SpecificationCategory.dimensions, translationKey: 'dimensions_total_height' },
    dimensions_frontwheeltrack: {
      category: SpecificationCategory.dimensions,
      translationKey: 'dimensions_distance_between_axles',
    },
    rearaxledistance: {
      category: SpecificationCategory.dimensions,
      translationKey: 'dimensions_distance_cab_to_rear_axle',
    },
    dimensions_wheelbase: { category: SpecificationCategory.dimensions, translationKey: 'dimensions_front_overhang' },
    dimensions_rearwheeltrack: {
      category: SpecificationCategory.dimensions,
      translationKey: 'dimensions_rear_overhang',
    },
    loadspace_lengthbehindfirstrow: {
      category: SpecificationCategory.dimensions,
      translationKey: 'dimensions_carriage_length_to_chassis',
    },
    wheelsize: { category: SpecificationCategory.dimensions, translationKey: 'dimensions_wheels_size' },
    warranty: { category: SpecificationCategory.dimensions },
    distancebetweenaxlesdisclaimer: { category: SpecificationCategory.dimensions },
  },
};

export default modelSpecificationsMap;
